import axios from 'axios';
// import axios from '../Axios';
// const API_URL = "http://127.0.0.1:8000/api";
// const API_URL = process.env.VUE_APP_API_BASE_URL;
// axios.defaults.baseURL = "https://backend.campfireadventure.net/api";
import authHeader from './auth-header';
const API_URL = "https://backend.campfireadventure.net/api";



export default {

  async login(user) {
    var response = await axios.post(`${API_URL}/auth/login`, {
      // var response = await axios.post(API_URL + '/auth/login', {
      username: user.username,
      password: user.password,
    },
      { headers: authHeader() }
    );
    console.log(response)
    if (response.data && response.data.data) {
      const userData = response.data.data;
      if (userData.token) {
        localStorage.setItem('user_free', JSON.stringify(userData.token));
        // localStorage.setItem('user_data', JSON.stringify(userData));
      }
      return userData;
    }
  },

  async logout() {
    await axios.post(`${API_URL}/auth/logout`, {}, { headers: authHeader() })
    // await axios.post("/auth/logout", {}, { headers: authHeader() })
    localStorage.removeItem('user_free');
  },

  // async register(user) {
  //   var response = await axios.post('/auth/register', {
  //     username: user.username,
  //     email: user.email,
  //     password: user.password,
  //     password_confirmation: user.confirmPassword
  //   });
  //   if (response.data.data.token) {
  //     localStorage.setItem('user_free', JSON.stringify(response.data.data.token));
  //   }
  //   return response.data;
  // },

}